import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "@/providers";
import { OrganizationTier } from "@/shared/domain/orgs/OrgRecord";

import { AISettings } from "./AISettings";
import { Integrations } from "./Integrations";
import { OAuthCallbackHandler } from "./McpConnections";
import { OrganizationSettings } from "./OrganizationSettings";
import { Secrets } from "./Secrets";
import { Tokens } from "./Tokens";
import { Usage } from "./Usage";

export function SettingsTabRoutes() {
  const { currentOrganization, currentUser } = useAuth();
  const isPremiumOrg = currentOrganization?.tier === OrganizationTier.Premium;

  return (
    <Routes>
      <Route
        path="organization"
        element={
          <OrganizationSettings
            currentOrg={currentOrganization}
            currentUser={currentUser}
          />
        }
      />
      <Route path="tokens" element={<Tokens />} />
      <Route path="usage" element={<Usage showGraphs={true} />} />
      <Route path="ai" element={<AISettings />} />
      <Route path="ai/mcp-callback" element={<OAuthCallbackHandler />} />
      <Route path="secrets" element={<Secrets />} />
      {isPremiumOrg && <Route path="integrations" element={<Integrations />} />}
      {/* Redirect old MCP routes to AI tab */}
      <Route
        path="integrations/register-mcp-server"
        element={<Navigate to="/settings/ai" replace />}
      />
      <Route
        path="mcp-connections"
        element={<Navigate to="/settings/ai" replace />}
      />
      <Route
        path="mcp-connections/callback"
        element={<OAuthCallbackHandler />}
      />
      <Route
        path="*"
        element={<Navigate to="/settings/organization" replace />}
      />
    </Routes>
  );
}
